import { render, staticRenderFns } from "./BudgetComponent.vue?vue&type=template&id=9371523a"
import script from "./BudgetComponent.ts?vue&type=script&lang=ts&external"
export * from "./BudgetComponent.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports